import type { Mandate } from "@kollectivia/shared";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";

export function useCompanyMandates(companyId: string | undefined) {
  return useQuery({
    queryKey: ["mandates", companyId],
    queryFn: () =>
      api.get<{ items: Mandate[] }>(`/v1/mandates?company_id=${encodeURIComponent(companyId!)}`),
    enabled: !!companyId,
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchInterval: 15_000,
    refetchIntervalInBackground: false,
  });
}
